import cn from 'clsx';
import { cloneElement, FC, isValidElement, memo, useMemo } from 'react';

import { IconType } from '../../../types';
import Icon from '../../Icon';

import s from './ContentsDescription.module.scss';
import { NativeAttrs } from './ContentsDescription.types';

interface Props {
  topMargin?: boolean;
  bottomMargin?: 'long' | 'short';
  textSize?: 13 | 14 | 16 | 18 | 20;
  listStyle?: IconType;
}

export type TextAreaProps = Props & NativeAttrs<Props, HTMLDivElement>;

const TextArea: FC<React.PropsWithChildren<React.PropsWithChildren<TextAreaProps>>> = ({
  topMargin = true,
  bottomMargin = 'long',
  textSize = 13,
  listStyle,
  children,
  ...props
}) => {
  const textStyle = useMemo(() => {
    if (textSize === 13 || textSize === 14) {
      return `body-${textSize}`;
    }
    if (textSize === 16) {
      return `sub-title-${textSize}`;
    }
    return `headline-${textSize}`;
  }, [textSize]);

  const renderChildren = () => {
    if (!isValidElement(children) && !listStyle) {
      return children;
    }
    return cloneElement(
      <span>
        {listStyle && <Icon className="-mt-[0.125rem] mr-1" type={listStyle} size={4} />}
        {children}
      </span>
    );
  };

  return (
    <div
      {...props}
      className={cn(
        {
          [s['description__contents__textarea--top'] as string]: topMargin,
          [s['description__contents__textarea--bottom--long'] as string]: bottomMargin === 'long',
          [s['description__contents__textarea--bottom--short'] as string]: bottomMargin === 'short'
        },
        textStyle,
        props.className
      )}
    >
      {renderChildren()}
    </div>
  );
};

const MemoTextArea = memo(TextArea);
export default MemoTextArea;
